import { Modal } from "@mui/material";
import { CircularProgress } from "@mui/material";
import {
    ButtonRow,
    ModalWrapper,
    StyledBackdrop,
    StyledButton,
} from "../../../../single/AddProductModal/Styled";
import InfoIcon from "../../../../../../shared/svg/InfoIcon";

interface ConfirmModalProps {
    open: boolean;
    handleClose: Function;
    onClickConfirm: Function;
    children: React.ReactNode;
    confirmButtonText: string;
    isLoading?: boolean;
}

export const ConfirmModal = ({
    open,
    handleClose,
    onClickConfirm,
    children,
    confirmButtonText,
    isLoading = false,
}: ConfirmModalProps) => {
    return (
        <Modal
            open={open}
            onClose={() => !isLoading && handleClose()}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper
                isOpen={open}
                style={{
                    width: "300px",
                    minHeight: "auto",
                    gap: "24px",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <InfoIcon />

                {children}

                <ButtonRow>
                    <StyledButton onClick={() => handleClose()} disabled={isLoading}>
                        Huỷ bỏ
                    </StyledButton>
                    <StyledButton
                        variant="contained"
                        onClick={() => onClickConfirm()}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress size={16} color="inherit" />}
                        {confirmButtonText}
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
